// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function TextAreaInputNew(props) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.label,
                      className: "text-sm font-medium mb-2"
                    }),
                JsxRuntime.jsx("textarea", {
                      className: "outline-none border border-gray-400 h-40 w-full rounded px-3 py-2 text-sm",
                      value: props.value,
                      onChange: props.handleChange
                    })
              ]
            });
}

var make = TextAreaInputNew;

exports.make = make;
/* react/jsx-runtime Not a pure module */
